import { Keyword, LengthPercentage, Number, } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
import { Selective } from "@siteimprove/alfa-selective";
const { either } = Parser;
const parse = either(Keyword.parse("normal"), Number.parse, LengthPercentage.parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/line-height}
 * @internal
 */
export default Longhand.of(Keyword.of("normal"), parse, (value, style) => value.map((height) => {
    // We need the type assertion to help TS break a circular type reference:
    // this -> style.computed -> Longhands.Name -> Longhands.longhands -> this.
    const fontSize = style.computed("font-size").value;
    return (Selective.of(height)
        .if(LengthPercentage.isLengthPercentage, LengthPercentage.resolve(Resolver.lengthPercentage(fontSize, style)))
        .if(Number.isNumber, (value) => value.resolve())
        // Keywords are left untouched
        .get());
}), {
    inherits: true,
});
//# sourceMappingURL=line-height.js.map